import React from 'react';
import './ArticleComponentCSS/HorizontalRule.css'

const HorizontalRule = () => {
  return <hr className="hr" />;
};

export default HorizontalRule;
